<template>
  <div class="payment-method">
    <vue-recaptcha
      sitekey="6LfmVzcaAAAAAFaHZE-oKnaGHoSeYvL4GRkSZjnv"
      v-bind:loadRecaptchaScript="true"
      v-on:verify="onCaptchaVerified"
      v-if="captchaValid == false"
    ></vue-recaptcha>
    <div
      v-if="showPaymentMethodes && captchaValid"
      class="payment-select-container"
    >
      <div
        v-bind:class="{ active: selectedPaymentMethod == 'card' }"
        v-on:click="loadPayment('card')"
        class="payment-select-item"
      >
        <font-awesome-icon class="icon" icon="credit-card" />
        <span>Credit card</span>
      </div>
      <div
        v-for="(value, key) in paymentMethodes"
        v-bind:key="key"
        v-bind:value="key"
        v-on:click="loadPayment(value.type)"
        v-bind:class="{ active: selectedPaymentMethod == value.type }"
        class="payment-select-item"
      >
        <img
          v-bind:src="
            require('@/assets/payment-methodes/' + value.type + '.png')
          "
        />
      </div>
    </div>
    <span
      v-if="this.priceWithTax < 200 && this.selectedPaymentMethod == 'paypal'"
      class="paypal-hint"
      >Please note that we have to debit an amount of 1.00€ from your account to
      verify your Paypal account. The amount cannot be refunded afterwards.
    </span>
    <span
      v-if="
        this.priceWithTax < 200 &&
          this.selectedPaymentMethod === 'sepadirectdebit'
      "
      class="paypal-hint"
      >Please note that we have to debit an amount of 1.00€ from your account to
      verify your Sepa credentials. The amount cannot be refunded afterwards.
    </span>
    <span
      v-if="this.priceWithTax < 200 && this.selectedPaymentMethod == 'card'"
      class="paypal-hint"
      >Please note that we have to debit an amount of 1.00€ from your account to
      verify your credit card. The amount cannot be refunded afterwards.
    </span>
    <div
      v-if="
        showPaymentMethodes &&
          captchaValid &&
          this.$store.state.customerData.customerType == 2
      "
      class="company-confirm"
    >
      <span
        class="checkbox-container"
        v-bind:style="{
          border: '1px solid ' + companyUseValid,
        }"
      >
        <input v-model="companyUse" class="input" type="checkbox" />
      </span>
      <div>
        I hereby confirm that I am an entrepreneur or a vicarious agent of a
        company and confirm that the purchased service or digital product is
        purchased exclusively for entrepreneurial use. *
      </div>
    </div>
    <div
      v-if="
        showPaymentMethodes &&
          captchaValid &&
          this.$store.state.customerData.customerType == 1
      "
      class="right-of-withdrawal"
    >
      <span
        class="checkbox-container"
        v-bind:style="{
          border: '1px solid ' + rightOfWithdrawalValid,
        }"
      >
        <input v-model="rightOfWithdrawal" class="input" type="checkbox" />
      </span>
      <div>
        I have read the information about my
        <a
          target="blank"
          href="https://www.solar-fox.com/en/cancellation-notice.html"
          >right of withdrawal</a
        >. *
      </div>
    </div>
    <div
      v-if="
        showPaymentMethodes &&
          captchaValid &&
          this.selectedPaymentMethod == 'sepadirectdebit'
      "
      class="sepa-direct-debit"
    >
      <span
        class="checkbox-container"
        v-bind:style="{
          border: '1px solid ' + sepaDirectDebitValid,
        }"
      >
        <input v-model="sepaDirectDebit" class="input" type="checkbox" />
      </span>
      <div>
        By ticking this checkbox, you authorise (A) Adyen BV (Creditor ID
        NL48ZZ342764500000) to send instructions to your bank to debit your
        account and (B) your bank to debit your account in accordance with the
        instructions from Ayden BV. Note: As part of your rights, you are
        entitled to a refund from your bank under the terms and conditions of
        your agreement with your bank. A refund must be claimed within 8 weeks
        starting from the date on which your account was debited.
      </div>
    </div>
    <div id="payment-container"></div>
  </div>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "payment-method-view",
  data() {
    return {
      captchaValid: false,
      companyUseValid: "#e7e7e700",
      rightOfWithdrawalValid: "#e7e7e700",
      sepaDirectDebitValid: "#e7e7e700",
      companyUse: false,
      rightOfWithdrawal: false,
      showPaymentMethodes: false,
      sepaDirectDebit: false,
      paymentMethodes: [],
      supportedPaymentMethodes: [],
      selectedPaymentMethod: "",
      checkout: false,
      clientKey:
        "pub.v2.8015986183991063.aHR0cDovLzEwLjEwLjAuNjU6ODA4MA.dEvC-67fxqokUyWDLLLqpN4BYWjYEcaV1-aJlpcpacs",
    };
  },
  props: {
    title: String,
  },
  components: {
    "vue-recaptcha": VueRecaptcha,
  },
  computed: {
    subscriptionType() {
      return this.$store.state.subscriptionType;
    },
    priceWithTax() {
      return this.$store.state.priceWithTax;
    },
    priceWithoutTax() {
      return this.$store.state.priceWithoutTax;
    },
    calcPrice() {
      return this.subscriptionType.price / 100;
    },
    calcTax() {
      if (
        this.getCountryWithId(this.$store.state.customerData.country) != null
      ) {
        if (
          this.getCountryWithId(this.$store.state.customerData.country).tax !=
          null
        ) {
          if (
            this.$store.state.customerData.vatId != null &&
            this.$store.state.customerData.vatId != ""
          ) {
            return 0;
          }
          return (
            (this.calcPrice *
              this.getCountryWithId(this.$store.state.customerData.country)
                .tax) /
            100
          );
        }
      }
      return 0;
    },
    subscriptionPaymenTypes() {
      return this.$store.state.subscriptionPaymentTypes;
    },
    checkboxes() {
      // snake case for fox-api
      return {
        company_use: this.companyUse,
        right_of_withdrawal: this.rightOfWithdrawal,
        sepa_direct_debit: this.sepaDirectDebit,
      };
    },
    customerCountryInsideEu() {
      if (
        this.getCountryWithId(this.$store.state.customerData.country) != null
      ) {
        if (
          this.getCountryWithId(this.$store.state.customerData.country).tax !=
          null
        ) {
          return true;
        }
      }
      return false;
    },
  },
  async mounted() {
    if (this.$router.currentRoute.name == "subscription/payment") {
      await this.calcTotal();
    }
    if (window.location.hostname == "solarfox-subscriptions.local-dev") {
      this.onCaptchaVerified();
    }
  },
  methods: {
    onCaptchaVerified() {
      this.captchaValid = true;
      this.load();
    },
    calcTotal() {
      let total = this.subscriptionType.price / 100 + this.calcTax;
      this.$store.commit("assignPriceWithTax", total * 100);
      return total;
    },
    async load() {
      await this.$store.dispatch("getPaymentTypes");
      let value = this.priceWithTax;
      if (value == 0) {
        value = 100;
      }
      await this.$store.dispatch("getPaymentMethodes", {
        country_code: this.getCountryWithId(
          this.$store.state.customerData.country
        ).iso,
        shopper_locale: "en_US",
        currency: "EUR",
        value: value,
      });

      for (let i = 0; i < this.subscriptionPaymenTypes.length; i++) {
        this.supportedPaymentMethodes.push(
          this.subscriptionPaymenTypes[i].payment_type
        );
      }

      let methodes = this.$store.state.paymentMethodes.paymentMethods;
      for (let i = 0; i < methodes.length; i++) {
        if (this.supportedPaymentMethodes.includes(methodes[i].type)) {
          this.paymentMethodes.push(methodes[i]);
        }
      }
      // As an instance method inside a component
      this.$loadScript(
        "https://checkoutshopper-live.adyen.com/checkoutshopper/sdk/4.2.0/adyen.js"
      )
        .then(() => {
          this.showPaymentMethodes = true;
          this.loadPayment("card");
        })
        .catch(() => {
          // Failed to fetch script
        });
    },
    getCountryWithId(countryId) {
      for (let i = 0; i < this.$store.state.countries.length; i++) {
        if (this.$store.state.countries[i].id == countryId) {
          return this.$store.state.countries[i];
        }
      }
      return null;
    },
    async handleOnCancel(data, component) {
      this.$store.commit("assignPaymentLoading", false);
      // Sets your prefered status of the component when a PayPal payment is cancelled. In this example, return to the initial state.
      component.setStatus("ready");
    },
    async handleOnError(error) {
      if (this.checkFormData()) {
        await this.$store.dispatch("changeErrorMsg", {
          msg:
            "An unknown payment error has occured. ERROR CODE (" +
            error.error +
            ")",
          type: "negativ",
        });
      } else {
        await this.$store.dispatch("changeErrorMsg", {
          msg: "Please fill out all fields marked in red.",
          type: "negativ",
        });
      }
      this.$store.commit("assignPaymentLoading", false);
    },
    async handleOnSubmit(state, component) {
      state.isValid; // True or false. Specifies if all the information that the shopper provided is valid.
      state.data; // Provides the data that you need to pass in the `/payments` call.
      component; // Provides the active component instance that called this event.
      if (this.checkFormData()) {
        this.$store.commit("assignPaymentLoading", true);
        let paymentTypeId = null;
        let country = this.getCountryWithId(
          this.$store.state.customerData.country
        );
        for (let i = 0; i < this.subscriptionPaymenTypes.length; i++) {
          if (
            this.subscriptionPaymenTypes[i].payment_type ===
            this.selectedPaymentMethod
          ) {
            paymentTypeId = this.subscriptionPaymenTypes[i].id;
          }
        }

        if (this.$router.currentRoute.name === "subscription/payment") {
          let value = 100;
          if (!this.$store.state.vatCheckSuccessfull) {
            value = value + (value / 100) * country.tax;
          }
          let value_without_tax = 100;
          await this.$store.dispatch("updatePayment", {
            payment_data: state.data,
            currency: "EUR",
            value: value,
            value_without_tax: value_without_tax,
            paymentTypeId: paymentTypeId,
            tax: country.tax,
            country_name: country.country_name,
            checkboxes: this.checkboxes,
          });
        } else {
          let value = this.priceWithTax;
          let value_without_tax = this.priceWithoutTax;

          await this.$store.dispatch("getPayment", {
            payment_data: state.data,
            currency: "EUR",
            value: value,
            value_without_tax: value_without_tax,
            paymentTypeId: paymentTypeId,
            tax: country.tax,
            country_name: country.country_name,
            checkboxes: this.checkboxes,
          });
        }
        if (typeof this.$store.state.payment.action !== "undefined") {
          if (this.$store.state.payment.action.type === "redirect") {
            this.checkout
              .createFromAction(this.$store.state.payment.action)
              .mount("#payment-container");
          } else if (this.$store.state.payment.action.type === "threeDS2") {
            // Optional configuration for the challenge window size
            const threeDSConfiguration = {
              challengeWindowSize: "02",
              // Set to any of the following:
              // '02': ['390px', '400px'] -  The default window size
              // '01': ['250px', '400px']
              // '03': ['500px', '600px']
              // '04': ['600px', '400px']
              // '05': ['100%', '100%']
            };
            this.checkout
              .createFromAction(
                this.$store.state.payment.action,
                threeDSConfiguration
              )
              .mount("#threeDS2-container");
            this.$store.state.threeDS2Payment = true;
          } else if (this.$store.state.payment.action.type === "sdk") {
            component.handleAction(this.$store.state.payment.action);
          } else {
            await this.$store.dispatch("changeErrorMsg", {
              msg:
                "We could not fully complete the payment process. Please wait a few minutes before trying again and check your inbox for an order confirmation in case the payment was successful. Please reach out to support@solar-fox.com with ERROR ⁠3612EZ.",
              type: "negativ",
            });
          }
        } else {
          if (
            this.$store.state.payment.resultCode === "Authorised" ||
            this.$store.state.payment.resultCode === "Received"
          ) {
            if (this.$router.currentRoute.name === "subscription/payment") {
              await this.$store.commit("assignSubscriptionTypeLoaded", false);
              await this.$store.dispatch("getSubscription");
              await this.$store.commit("assignPaymentLoading", false);
              await this.$store.commit("assignSubscriptionTypeLoaded", true);
              await this.$store.dispatch("changeErrorMsg", {
                msg: "Your payment methode has been changed successfully.",
                type: "positiv",
              });
            } else {
              await this.$store.commit("assignPaymentLoading", false);
              await this.$store.commit(
                "assignOrderErrorVisible",
                this.$store.state.payment.email_failed
              );
              this.$router.push(this.$store.state.payment.redirect_url);
            }
          }
          if (this.$store.state.payment.resultCode === "Refused") {
            this.$store.commit("assignPaymentLoading", false);
            component.setStatus("ready");
            await this.$store.dispatch("changeErrorMsg", {
              msg:
                "Your payment was refused. Refusal reason (" +
                this.$store.state.payment.refusalReason +
                ")",
              type: "negativ",
            });
          }
          if (this.$store.state.payment.resultCode === "Error") {
            await this.$store.dispatch("changeErrorMsg", {
              msg:
                "We could not fully complete the payment process. Please wait a few minutes before trying again and check your inbox for an order confirmation in case the payment was successful. Please reach out to support@solar-fox.com with ERROR 4723RU.",
              type: "negativ",
            });
            this.$store.commit("assignPaymentLoading", false);
            component.setStatus("ready");
          }
        }
      } else {
        await this.$store.dispatch("changeErrorMsg", {
          msg: "Please fill out all fields marked in red.",
          type: "negativ",
        });
      }
    },
    async handleOnAdditionalDetails(state, component) {
      state.data; // Provides the data that you need to pass in the `/payments/details` call.
      component; // Provides the active component instance that called this event.
      let paymentTypeId = null;
      let country = this.getCountryWithId(
        this.$store.state.customerData.country
      );
      if (this.$store.state.threeDS2Payment === true) {
        this.$store.state.threeDS2Payment = false;
      }
      for (let i = 0; i < this.subscriptionPaymenTypes.length; i++) {
        if (
          this.subscriptionPaymenTypes[i].payment_type ==
          this.selectedPaymentMethod
        ) {
          paymentTypeId = this.subscriptionPaymenTypes[i].id;
        }
      }
      if (this.$router.currentRoute.name == "subscription/payment") {
        let value = 100;
        let value_without_tax = 100;

        await this.$store.dispatch("updatePaymentDetails", {
          payment_details_data: state.data,
          paymentTypeId: paymentTypeId,
          value: value,
          value_without_tax: value_without_tax,
          tax: country.tax,
          country_name: country.country_name,
          checkboxes: this.checkboxes,
        });
      } else {
        let value = this.priceWithTax;
        let value_without_tax = this.priceWithoutTax;
        await this.$store.dispatch("getPaymentDetails", {
          payment_details_data: state.data,
          paymentTypeId: paymentTypeId,
          value: value,
          value_without_tax: value_without_tax,
          tax: country.tax,
          country_name: country.country_name,
          checkboxes: this.checkboxes,
        });
      }
      if (
        this.$store.state.paymentDetails.resultCode == "Received" ||
        this.$store.state.paymentDetails.resultCode == "Authorised"
      ) {
        if (this.$router.currentRoute.name == "subscription/payment") {
          await this.$store.commit("assignSubscriptionTypeLoaded", false);
          await this.$store.dispatch("getSubscription");
          await this.$store.commit("assignPaymentLoading", false);
          await this.$store.commit("assignSubscriptionTypeLoaded", true);
        } else {
          this.$store.commit("assignPaymentLoading", false);
          this.$router.push(this.$store.state.paymentDetails.redirect_url);
          component.setStatus("success");
        }
      }

      if (this.$store.state.paymentDetails.resultCode == "Refused") {
        let msg = "The payment was refused!";
        if (
          this.$store.state.paymentDetails.refusalReason ===
          "3D Not Authenticated"
        ) {
          msg =
            "3D-Authentication failed! Your entered credentials are incorrect.";
        }
        await this.$store.dispatch("changeErrorMsg", {
          msg: msg,
          type: "negativ",
        });
        this.$store.commit("assignPaymentLoading", false);
        component.setStatus("ready");
      }
      if (this.$store.state.paymentDetails.resultCode == "Error") {
        await this.$store.dispatch("changeErrorMsg", {
          msg:
            "We could not fully complete the payment process. Please wait a few minutes before trying again and check your inbox for an order confirmation in case the payment was successful. Please reach out to support@solar-fox.com with ERROR 5834TI.",
          type: "negativ",
        });
        this.$store.commit("assignPaymentLoading", false);
        component.setStatus("ready");
      }
    },
    handleOnChange(state, component) {
      state.isValid; // True or false. Specifies if all the information that the shopper provided is valid.
      state.data; // Provides the data that you need to pass in the `/payments` call.
      component; // Provides the active component instance that called this event.
      component.setStatus("ready");
    },
    async loadPayment(method) {
      if (method == "paypal") {
        if (!this.checkFormData()) {
          await this.$store.dispatch("changeErrorMsg", {
            msg: "Please fill out all fields marked in red.",
            type: "negativ",
          });
          return false;
        }
      }
      this.selectedPaymentMethod = method;
      this.showPayment = true;
      var paymentMethodsResponse = this.$store.state.paymentMethodes;
      if (window.location.hostname == "solarfox-subscriptions.local-dev") {
        this.clientKey =
          "pub.v2.8015986183991063.aHR0cDovL3NvbGFyZm94LXN1YnNjcmlwdGlvbnMubG9jYWwtZGV2.qNILiUPNhdXwP6o_Pw1_nGuhLi1fyf3N_WZBtVtySi4";
      }
      if (window.location.hostname == "10.10.0.65") {
        this.clientKey =
          "pub.v2.8015986183991063.aHR0cDovLzEwLjEwLjAuNjU6ODA4MA.dEvC-67fxqokUyWDLLLqpN4BYWjYEcaV1-aJlpcpacs";
      }
      if (window.location.hostname == "solarfox-subscriptions.svcs.sf.int") {
        this.clientKey =
          "pub.v2.2616160683332576.aHR0cDovL3NvbGFyZm94LXN1YnNjcmlwdGlvbnMuc3Zjcy5zZi5pbnQ.92yUSFk5WzVVqleAAoGjkyYeJnr_UqXyOSePxlXrKzI";
      }
      if (window.location.hostname == "subscriptions.solar-fox.com") {
        this.clientKey =
          "pub.v2.2616160683332576.aHR0cHM6Ly9zdWJzY3JpcHRpb25zLnNvbGFyLWZveC5jb20.fX1z_LodlBoyUxgVkmLysWDsCtrTlxV_WN67dOZYuwA";
      }

      let environment = "live";
      let gatewayMerchantId = "SOLEDOSGmbH090";
      let merchantId = "GL28WCF8ZSJNU";
      if (window.location.hostname == "solarfox-subscriptions.local-dev") {
        environment = "test";
        gatewayMerchantId = "Soledos";
        merchantId = "ZSQASS4XUFBCY";
      }
      const configuration = {
        locale: "en_US", // The shopper's locale. For a list of supported locales, see https://docs.adyen.com/checkout/components-web/localization-components.
        environment: environment, // When you're ready to accept live payments, change the value to one of our live environments https://docs.adyen.com/checkout/components-web#testing-your-integration.
        clientKey: this.clientKey, // Your client key. To find out how to generate one, see https://docs.adyen.com/development-resources/client-side-authentication. Web Components versions before 3.10.1 use originKey instead of clientKey.
        paymentMethodsResponse: paymentMethodsResponse, // The payment methods response returned in step 1.
        onChange: this.handleOnChange, // Your function for handling onChange event
        onAdditionalDetails: this.handleOnAdditionalDetails, // Your function for handling onAdditionalDetails event
        onSubmit: this.handleOnSubmit,
        onError: this.handleOnError,
        onCancel: this.handleOnCancel,
        showPayButton: true,
        amount: {
          currency: "EUR",
        },
        countryCode: this.getCountryWithId(
          this.$store.state.customerData.country
        ).country_code,
      };
      if (this.$router.currentRoute.name != "subscription/payment") {
        configuration.amount.value = Math.round(
          (this.priceWithTax * 100) / 100
        );
      }
      if (method == "paypal") {
        configuration.merchantId = merchantId;
        configuration.intent = "capture";
        configuration.style = {
          // Example optional configuration for PayPal.
          color: "blue",
        };
      }
      if (method == "paywithgoogle") {
        configuration.gatewayMerchantId = gatewayMerchantId;
        //configuration.merchantIdentifier = "";
        configuration.merchantName = "Soledos GmbH";
        //configuration.buttonColor = "white";
      }
      if (method == "card") {
        // configuration.hasHolderName = true;
        // configuration.holderNameRequired = true;
        // configuration.billingAddressRequired = true;
      }
      // eslint-disable-next-line
      this.checkout = new AdyenCheckout(configuration);
      if (document.getElementById("payment-container")) {
        this.checkout.create(method).mount("#payment-container");
      }
    },
    checkFormData() {
      let formDataValid = true;

      if (
        this.$store.state.customerData.email == "" ||
        this.$store.state.customerData.email == null
      ) {
        this.$store.commit("assignEmailValid", "red");
        formDataValid = false;
      } else {
        this.$store.commit("assignEmailValid", "#e7e7e7");
      }
      if (
        this.$store.state.customerData.firstname == "" ||
        this.$store.state.customerData.firstname == null
      ) {
        this.$store.commit("assignFirstnameValid", "red");
        formDataValid = false;
      } else {
        this.$store.commit("assignFirstnameValid", "#e7e7e7");
      }
      if (
        this.$store.state.customerData.secondname == "" ||
        this.$store.state.customerData.secondname == null
      ) {
        this.$store.commit("assignSecondnameValid", "red");
        formDataValid = false;
      } else {
        this.$store.commit("assignSecondnameValid", "#e7e7e7");
      }
      if (
        (this.$store.state.customerData.company == "" ||
          this.$store.state.customerData.company == null) &&
        this.$store.state.customerData.customerType != 1
      ) {
        this.$store.commit("assignCompanyValid", "red");
        formDataValid = false;
      } else {
        this.$store.commit("assignCompanyValid", "#e7e7e7");
      }
      if (
        this.$store.state.customerData.street == "" ||
        this.$store.state.customerData.street == null
      ) {
        this.$store.commit("assignStreetValid", "red");
        formDataValid = false;
      } else {
        this.$store.commit("assignStreetValid", "#e7e7e7");
      }
      if (
        this.$store.state.customerData.houseNumber == "" ||
        this.$store.state.customerData.houseNumber == null
      ) {
        this.$store.commit("assignHouseNumberValid", "red");
        formDataValid = false;
      } else {
        this.$store.commit("assignHouseNumberValid", "#e7e7e7");
      }
      if (
        this.$store.state.customerData.zip == "" ||
        this.$store.state.customerData.zip == null
      ) {
        this.$store.commit("assignZipValid", "red");
        formDataValid = false;
      } else {
        this.$store.commit("assignZipValid", "#e7e7e7");
      }
      if (
        this.$store.state.customerData.city == "" ||
        this.$store.state.customerData.city == null
      ) {
        this.$store.commit("assignCityValid", "red");
        formDataValid = false;
      } else {
        this.$store.commit("assignCityValid", "#e7e7e7");
      }
      if (this.$router.currentRoute.name != "subscription/payment") {
        if (
          this.$store.state.customerData.privacyPolicy == "" ||
          this.$store.state.customerData.privacyPolicy == null ||
          this.$store.state.customerData.privacyPolicy == false
        ) {
          this.$store.commit("assignPrivacyPolicyValid", "red");
          formDataValid = false;
        } else {
          this.$store.commit("assignPrivacyPolicyValid", "#e7e7e700");
        }
        if (
          this.$store.state.customerData.termsConditions == "" ||
          this.$store.state.customerData.termsConditions == null ||
          this.$store.state.customerData.termsConditions == false
        ) {
          this.$store.commit("assignTermsConditionsValid", "red");
          formDataValid = false;
        } else {
          this.$store.commit("assignTermsConditionsValid", "#e7e7e700");
        }
        if (
          this.$store.state.customerData.customerType == 2 &&
          this.customerCountryInsideEu &&
          this.getCountryWithId(this.$store.state.customerData.country).id != 57
        ) {
          if (this.$store.state.vatCheckSuccessfull == false) {
            this.$store.commit("assignVatValid", "red");
            formDataValid = false;
          } else {
            this.$store.commit("assignVatValid", "#e7e7e7");
          }
        } else {
          this.$store.commit("assignVatValid", "#e7e7e7");
        }
      }
      if (
        (this.companyUse == "" ||
          this.companyUse == null ||
          this.companyUse == false) &&
        this.$store.state.customerData.customerType == 2
      ) {
        this.companyUseValid = "red";
        formDataValid = false;
      } else {
        this.companyUseValid = "#e7e7e700";
      }
      if (
        (this.rightOfWithdrawal == "" ||
          this.rightOfWithdrawal == null ||
          this.rightOfWithdrawal == false) &&
        this.$store.state.customerData.customerType == 1
      ) {
        this.rightOfWithdrawalValid = "red";
        formDataValid = false;
      } else {
        this.rightOfWithdrawalValid = "#e7e7e700";
      }
      if (
        (this.sepaDirectDebit === "" ||
          this.sepaDirectDebit === null ||
          this.sepaDirectDebit === false) &&
        this.selectedPaymentMethod === "sepadirectdebit"
      ) {
        this.sepaDirectDebitValid = "red";
        formDataValid = false;
      } else {
        this.sepaDirectDebitValid = "#e7e7e700";
      }
      return formDataValid;
    },
  },
};
</script>

<style scoped>
.company-confirm {
  width: 100%;
  padding-top: 10px;
  margin-top: 10px;
  display: flex;
  font-size: 11px;
  align-items: center;
  border-top: 1px solid #cfcfcf;
}

.sepa-direct-debit {
  width: 100%;
  margin-top: 10px;
  display: flex;
  font-size: 11px;
  align-items: center;
}

.right-of-withdrawal a {
  color: #888888;
}

.right-of-withdrawal {
  width: 100%;
  padding-top: 10px;
  /* margin-top: 10px; */
  display: flex;
  font-size: 11px;
  align-items: center;
}

.checkbox-container {
  border-radius: 4px;
  margin-right: 10px;
}

.right-of-withdrawal input,
.sepa-direct-debit input,
.company-confirm input {
  height: 20px;
  width: 20px;
  margin: 0;
}

.payment-method {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.payment-select-container {
  width: 100%;
  height: 20%;
  display: flex;
  margin-top: 10px;
  flex-wrap: wrap;
  overflow: auto;
}

.payment-select-item:hover {
  border: 1px solid #ffc20f;
  background-color: #fceab5;
}

.payment-select-item {
  height: 55px;
  border: 1px solid #cfcfcf;
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 4px;
  margin-right: 10px;
  color: black;
  cursor: pointer;
}
.payment-select-item .icon {
  margin-right: 5px;
}

.payment-select-item img {
  height: 100%;
}

#payment-container {
  height: 70%;
  width: 100%;
  margin-top: 10px;
  padding-top: 20px;
  border-top: 1px solid #cfcfcf;
  overflow: auto;
}

.active {
  border: 1px solid #ffc20f;
}
.paypal-hint {
  font-size: 11px;
  color: red;
}
</style>
